<template>
  <div class="empty-bgc">
      <img src="../../images/empty-learning.png" alt="" class="empty-img">
      <p class="empty-p">{{content}}</p>
  </div>
</template>

<script>
export default {
  name: 'EmptyLearning',
  props: {
    content: {
      default: '暂无数据~',
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-bgc{
    .empty-img{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 40%;

    }
    .empty-p{
      position: absolute;
      top: 85%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
}

</style>
